import { render, staticRenderFns } from "./RootModule.vue?vue&type=template&id=9f7f424c&scoped=true&"
import script from "./RootModule.vue?vue&type=script&lang=js&"
export * from "./RootModule.vue?vue&type=script&lang=js&"
import style0 from "./RootModule.vue?vue&type=style&index=0&id=9f7f424c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7f424c",
  null
  
)

export default component.exports